export default {
  add_products: '+ Ajouter des produits',
};
